import React, { useEffect, useState } from 'react'
import PrimaryButton from '../../components/globalComponents/buttons/primaryButton/PrimaryButton'
import Dropdown from '../../components/globalComponents/dropdown/Dropdown'
import TextField from '../../components/globalComponents/textFields/TextField'
import ConfirmationPopup from '../../components/popups/confirmationPopup/ConfirmationPopup'
import StudentListPopup from '../../components/popups/studentListPopup/StudentListPopup'
import UploadCSVPopup from '../../components/popups/uploadCSVPopup/UploadCSVPopup'
import SunEditor from "suneditor-react";
import mergeTag from '../../components/globalComponents/Editor/EditorPlugin';
import "suneditor/dist/css/suneditor.min.css";
import './CreateRecordStyle.css'
import { useNavigate } from 'react-router-dom'
import { getAllLists, emailData, sendMailToStudents, addStudentsToList, downloadSampleEmailCSV, clearState } from '../../reducers/emailSlice'
import { useDispatch, useSelector } from "react-redux";
import PageLoader from '../../components/globalComponents/PageLoader/PageLoader'
import EditEmailListPopup from '../../components/popups/editEmailListPopup/EditEmailListPopup'
import AddStudentPopup from '../../components/popups/addStudentPopup/addStudentPopup'


const CreateRecord = () => {

    const { isFetching, sampleFileDownload, mailSent, saved, listData, uploaded, studentAdded } = useSelector(emailData);

    const navigate = useNavigate();

    const [subject, setSubject] = useState('');
    const [isAddListOpen, setIsAddListOpen] = useState(false);
    const [isEditMailOpen, setIsEditMailOpen] = useState(false);
    const [isAddStdOpen, setIsAddStdOpen] = useState(false);

    const [listId, setListId] = useState('');
    const [listName, setListName] = useState('');
    const [emailBody, setEmailBody] = useState('');
    const [file, setFile] = useState();



    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllLists());
        dispatch(downloadSampleEmailCSV());
        dispatch(clearState());
    }, [])

    useEffect(() => {
        if (listData && listData.length > 0) {
            setListId(listData[0]._id);
        }
    }, [listData])

    useEffect(() => {
        if (isAddListOpen) {
            setIsAddListOpen(false);
            setTimeout(() => {
                dispatch(getAllLists());
            }, 400);
        }
    }, [uploaded]);

    useEffect(() => {
        if (isEditMailOpen) {
            setIsEditMailOpen(false);
        }
    }, [saved]);

    useEffect(() => {
        if (isAddStdOpen) {
            setIsEditMailOpen(true);
            setIsAddStdOpen(false);
        }
    }, [studentAdded]);

    useEffect(() => {
        if (mailSent) {
            dispatch(clearState());
            navigate('/');
        }
    }, [mailSent])


    const onMailSend = () => {
        console.log('data');

        let data = { subject, listId, emailBody };
        console.log(data)
        if (subject !== '' && listId !== '') {
            dispatch(sendMailToStudents(data))
        }
    }

    const onUpload = (event) => {
        console.log("onUpload");
        if (event.target.files.length > 0) {
            setFile(event.target.files[0]);
        }
    };

    const onUploadClick = () => {
        let obj = {
            file, listName
        }
        if (file && listName !== '') {
            dispatch(addStudentsToList(obj));
        }
    }

    return (
        <>
            {isFetching && <PageLoader />}
            {/* <ConfirmationPopup/> */}
            {isAddStdOpen && <AddStudentPopup onClose={() => { setIsAddStdOpen(false); setIsEditMailOpen(true) }} listId={listId} />}
            {isEditMailOpen && <EditEmailListPopup setIsAddStdOpen={() => setIsAddStdOpen(true)} onToggle={() => setIsEditMailOpen(false)} onClose={() => {setIsEditMailOpen(false);}} listData={listData} currListId={listId} setCurrListId={(x) => setListId(x)}/>}
            {isAddListOpen && <UploadCSVPopup onListChange={(e) => setListName(e.target.value)} onClick={() => setIsAddListOpen(false)} onUpload={onUpload} onUploadClick={onUploadClick} csvFileDownload={sampleFileDownload} listId={listId} />}
            {/* <StudentListPopup/> */}
            <div className="pageHeader createRecordHeader">
                <div className="backBtn" onClick={() => navigate(-1)}>
                    <img src="../assets/icons/back-btn.svg" alt="" />
                    Back to Page
                </div>
            </div>
            <div className="createRecordContainerOuter">
                <div className="createRecordContainer">
                    <TextField labelName={'Email Subject'} placeholder={'Write the Subject'} isImportant={true} onChange={(e) => setSubject(e.target.value)} />
                    <div className="form2Col">
                        <div className="formGroup">
                            <label htmlFor="dropdown" className="formLabel">
                                Select List <span className="impMark">*</span>
                            </label>
                            <select name="lists" id="lists" className='formInput' onChange={(e) => setListId(e.target.value)}>
                                {listData.map((list) => (
                                    <option key={list._id} value={list._id}>{list.name}</option>
                                ))}
                            </select>
                            {/* <Dropdown label={'Select List'} isImportant={true}  /> */}
                            {/* <i>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00004 2.83325C8.27618 2.83325 8.50004 3.05711 8.50004 3.33325V7.49992H12.6667C12.9428 7.49992 13.1667 7.72378 13.1667 7.99992C13.1667 8.27606 12.9428 8.49992 12.6667 8.49992H8.50004V12.6666C8.50004 12.9427 8.27618 13.1666 8.00004 13.1666C7.7239 13.1666 7.50004 12.9427 7.50004 12.6666V8.49992H3.33337C3.05723 8.49992 2.83337 8.27606 2.83337 7.99992C2.83337 7.72378 3.05723 7.49992 3.33337 7.49992H7.50004V3.33325C7.50004 3.05711 7.7239 2.83325 8.00004 2.83325Z" fill="black" />
                            </svg>
                        </i> */}
                        </div>
                        <div className="formGroup formGroupWidth">
                            <PrimaryButton classname={'primaryBtn'} children={'Edit List'} onClick={() => setIsEditMailOpen(true)} />
                            <PrimaryButton classname={'primaryBtn'} children={'Add List'} onClick={() => setIsAddListOpen(true)} />
                        </div>
                    </div>

                    <div className="editorBox">
                        <SunEditor
                            setContents='<table style="max-width:540px;margin:0 auto;border:1px solid #333;font-family:Arial,Helvetica,sans-serif;color:#333333;margin-top:50px;margin-bottom:50px"> <tbody> <tr> <td style="padding:40px 20px;padding-top:30px;padding-bottom:0"> <div><img alt="Header" src="https://cdn.mastersunion.org/assets/imgV2/egLogo.png" class="CToWUd" data-bit="iit" data-origin="150," style="width: 150px;"> </div> </td> </tr> <tr> <td style="padding:20px 20px;padding-top:0;"> <div> <br>Kjære [kundenavn],&nbsp; <br> <br>Håper denne e-posten finner deg godt. Jeg skriver for å introdusere [Bedriftsnavn] og presentere vårt omfattende utvalg av transporttjenester. <br> <br>Vi er glade for å kunne tilby skreddersydde transportløsninger som møter dine behov for godstransport. Med lang erfaring i bransjen og et dedikert team av yrkessjåfører og logistikkpersonell er vi godt rustet til å håndtere ulike transportutfordringer i hele Norge. <br> <br>Vestlandet: Bergen - 1 Thermo Trolley med bom mot Østlandet. <br> <br>Trøndelag: Trondheim - Kapellvogn på vei til Østlandet. <br> <br>Oslo: Muligheter for trilleturer, ADHOC-kjøring eller Ekspress Thermo, stykkgods, Kapell, CitySemi med lemSi. <br> <br>Vi er stolte av vårt dedikerte team som alltid er klare til å møte dine spesifikke transportbehov og gi deg logistikkløsninger - 24 timer i døgnet, 365 dager i året. <br> <br>Vi diskuterer gjerne dine spesifikke krav og utarbeider en skreddersydd transportløsning som passer deg best. Kontakt oss på telefon [telefonnummer] eller e-post [e-postadresse] for mer informasjon eller for å avtale en konsultasjon. <br> <br>Vi ser frem til å betjene deg og bidra til en problemfri transportopplevelse. Takk for din interesse for [Bedriftsnavn]. <br> <br>Med beste ønsker, <br> <br>[Navnet ditt] <br>[Poengsum] <br>[Selskapsnavn] <br>[Telefonnummer] <br>[Epostadresse] <br> <p style="display:inline-block;margin-top:0px;width:100%;font-weight: bold;margin-bottom: 0px;font-size: 18px;"><br> </p> </div> </td> </tr> <tr> <td style="padding:30px 20px;padding-top:0;text-align: center;"> <div style="width:auto"><a href="https://www.facebook.com/egron.no"><img src="https://cdn.mastersunion.org/assets/imgV2/facebookIconn.png" class="CToWUd" data-bit="iit" data-origin="32," style="width:32px;margin:20px 0px 0px 10px;box-sizing:content-box"></a><a href="https://www.instagram.com/egron.as/"><img src="https://cdn.mastersunion.org/assets/imgV2/instagramIconn.png" class="CToWUd" data-bit="iit" data-origin="32," style="width:32px;margin:20px 0px 0px 10px;box-sizing:content-box"></a><a href="https://www.linkedin.com/company/egron-transport-as/mycompany/?viewAsMember=true"><img src="https://cdn.mastersunion.org/assets/imgV2/linkedinIconn.png" class="CToWUd" data-bit="iit" data-origin="32," style="width:32px;margin:20px 0px 0px 10px;box-sizing:content-box"></a></div> <p style="display: inline-block;width: auto;">Besøksadresse: <a href="https://www.google.com/maps/search/Knud+Bryns+vei+1+,+0583+Oslo?entry=gmail&amp;source=g" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://www.google.com/maps/search/Knud%2BBryns%2Bvei%2B1%2B,%2B0583%2BOslo?entry%3Dgmail%26source%3Dg&amp;source=gmail&amp;ust=1676433997259000&amp;usg=AOvVaw22FfVUC5rTDs5zfT0vtuyR">Knud Bryns vei 1 , 0583 Oslo</a></p> <p style="display: block;margin-top: 5px;">Tlf: <strong>48 94 88 99</strong></p><p style="display: inline-block;width: auto;"> <a href="https://u32572760.ct.sendgrid.net/ls/click?upn=YtjN-2BZJZb-2BMO9yD-2B8xJXiI0DRPOFhu2jeChHN3XNAqjZcNAU2OJ48I4tUV4X0vzDDT-2FLOYMWJTyoXs4wbyOGhMiCgvMXNPpvSctPHXj-2FhSlQ2Tiw3KCznfs841-2B0OZEw0-2FER-2BlL60S1-2FNYqy9fLPFf9FP4bGtY4LMLMnvV-2B1qG2p3fIqXE0rDkOE23r89SiKIPx-2F3p5aXYbVahQEkmwKRVVxYnmia69T0TjgYgYDYzA9Fbdl7kWNGyvrGJEEFGwY5NBTQ0AdU9vCNIcuzFgagR-2FkLgvttpLShydq6xINsuSpGPAqRvaPFmqOkocrCJB8nsHQAiPPyp-2BjGkJMI9k2sKcOq-2FV3R8xAol-2FbjCITuibbYaWMZStOyI1qfootpEWIRUPuITw9aAbeEx-2FqKKB-2F7B-2BMj33FiSDL4yKPwCz0Fg-2FzFwDW-2Bk0VAzDo3kxDxwu1c1hXWfLd7joEIAM39Zz9vaZmpgkuZeKQRvdAeCvrR0-2BUoyU701y1Jn28TxdAB-2BkSpPacBwrFc5ziE3mPr9FJZ88PoR0IPsVzGqMJEuFqGyyT71rrrf3iqtinZQEyqY2oaiQEPeNG777kRl-2FAyAULi-2FqMIfKdM7dZo9UZ-2BEN-2BFxlwgcIpL1uCGa3iWprRMRRv7eLDfy2AVHnEQgYweemI8jCKaBWiwJDYiFdYbzI-2Bd34E5APgreiR42kiUw0dKqvQESN2nYI1fTcToIaWrsV3ZQDv1yO3zpicXDriLDtvvh6YZ1ti7jAjosgTy4K4-2BxPeiouTNvMgzTUpEtvcioAPk1b47n-2F4-2BLZESVA6Xt78kWdV4fXGkEOeBf4a4efXDNxIPP-2BNcQUST0atiyGkJk983tUDNc34ipdH2QkMR-2BXjb-2BEolIPDwTv8tgpmkF5ujbmDpCFMwdmdkFNZV9g7hXgZjWrGfxUTkanpULmhCHW6SBuHXcb15KtqJH1oF9RNc4-2BRqAQwtI0apI1Whlk8uAZ8OZOSZzEihSwVomZf0tVnZggOChkBqu34kDzw4ThFh4dzMrNzMKwzLTviFfatQFNopGPKsK-2FT4iSn1KQsUev-2FUDuk-2Bef0WBSNz4XJx7BpymHhrKokjylGPFokEws1IIq2zIdzZiVyVSVBZFN2h8O5kv9ADu2YnhTLmvbOGdbpxblHzT5XT1PmJRL-2B1-2FJmR7ER9nQll5RBe5nrxeJNmwIo7Nw-3DUzMt_D9ca14QZ1kak4faDukVSzUzgb5918JZDgyv-2B5Dq9fSxarrkIA8KWYpEc26SwGGpRgJU-2BWhWU0SZsYm1Vl3OsJ7TBz60bTTe08fz-2Fku4BIwbEEuy-2By0qxXZRseop6TmF3mg-2BVDGTDLVolanfmXj4DVpyi2yIwMXx6r0qIpr6DV3cBmbCDV8OCnAaKBvLjTUM99b863OiIv1p0hTrOHXCNZiX6BuYX0X-2BGeocAcOf6Gps-3D" target="_blank">Avslutt abonnement på e-poster</a></p> </td> </tr> </tbody></table>'
                            // setContents={""}
                            showToolbar={true}
                            onChange={setEmailBody}
                            setDefaultStyle="height: auto;"
                            setOptions={{
                                plugins: [mergeTag],
                                buttonList: [
                                    [
                                        "bold",
                                        "underline",
                                        "italic",
                                        "strike",
                                        "list",
                                        "align",
                                        "fontSize",
                                        "formatBlock",
                                        "table",
                                        "fullScreen",
                                        "preview",
                                        "codeView",
                                    ],
                                    [
                                        {
                                            name: "merge_tag",
                                            dataCommand: "merge_tag",
                                            buttonClass: "",
                                            title: "Add Token",
                                            dataDisplay: "submenu",
                                            innerHTML: "<span>Token</span>",
                                        },
                                    ],
                                ],
                            }}
                        />
                    </div>
                    <div className="formFooter">
                        <PrimaryButton classname={'primaryBtn'} children={'Send Mail'} onClick={onMailSend} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreateRecord